import {ICampaignStatusEnum} from '../../campaigns/interfaces/ICampaigns';
import OrderLists from '../components/list';

const OrderPending = () => {
  return <OrderLists status={ICampaignStatusEnum.PENDING} />;
};

export default OrderPending;
